/**
 * Resolve an alarm-namespace translation key with optional commercial-tenant
 * override. Uses i18next's `context` feature: when `isBillboard === false`,
 * t('alarms.foo', { context: 'commercial' }) resolves alarms.foo_commercial
 * if present, falling back to alarms.foo. Billboard tenants get the base key.
 *
 * Define a _commercial entry in the locale only for keys that actually
 * differ; keep the base key for everything else.
 */
export function tAlarm(t, key, isBillboard, options = {}) {
  return t(key, { ...options, context: isBillboard ? undefined : 'commercial' });
}
